import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import Loader from "../../../components/shared/Loader";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import { updateMeta } from "../../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { checkPermissions } from "../../../helpers/authentication/checkPermissions";

const PositionsIndex = () => {
	const [positions, setPositions] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع الوظائف المطلوبة",
				breadcrumb: "التوظيف",
				button: {
					permissions: ["position-create"],
					show: true,
					text: "اضافة وظيفة جديدة",
					link: "/positions/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/postions`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setPositions(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const columns = [
		{
			name: "العنوان",
			selector: "title",
			sortable: true,
		},
		{
			name: "النوع",
			selector: "type",
			sortable: true,
		},
		{
			name: "",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					{checkPermissions(["position-edit"]) && (
						<li className="list-inline-item">
							<Link
								className="bt bt-success bt-sm"
								to={`/positions/show/${row.id}`}
							>
								<i className="fas fa-edit"></i>
							</Link>
						</li>
					)}
					{checkPermissions(["position-delete"]) && (
						<li className="list-inline-item">
							<button
								className="bt bt-danger bt-sm"
								onClick={() => handleConfrimDelete(row.id)}
								aria-label="حذف"
							>
								<i className="fas fa-trash"></i>
							</button>
						</li>
					)}
				</ul>
			),
		},
	];

	const handleConfrimDelete = positionID => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteArticle(positionID),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteArticle = positionID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/postions/${positionID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<DataTableExtensions columns={columns} data={positions}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default PositionsIndex;
